<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M6.97077 10.6379L7.69503 10.0929C8.28932 9.64577 9.02565 9.50083 9.7098 9.64382L12.0462 5L14.4312 9.80263L14.9054 9.36663C14.6767 9.01686 14.5333 8.60626 14.5046 8.16438L14.4993 8C14.4993 7.42855 14.6909 6.90189 15.0135 6.48082L13.8363 4.11024C13.1033 2.63422 11.0002 2.62874 10.2596 4.10092L6.97077 10.6379Z"
      fill="#636363"
    />
    <path
      d="M18.2791 13.0567L16.7468 14.4657L18.9986 19H5.0026L5.5083 17.9948L5.50426 17.9979C4.79324 18.5329 3.88954 18.6309 3.11475 18.3376C2.66225 19.61 3.6009 21 5.00202 21H18.998C20.4821 21 21.4489 19.4397 20.7887 18.1102L18.2791 13.0567Z"
      fill="#636363"
    />
    <path
      d="M18.998 11V10.3584L12.9378 15.9312C12.572 16.2676 12.0211 16.2808 11.641 15.9795L11.5498 15.8976L9.09985 13.415L4.60326 16.7992C4.19597 17.1056 3.63061 17.0536 3.28499 16.6967L3.20339 16.6011C2.89702 16.1937 2.94898 15.6282 3.30583 15.2825L3.40136 15.2008L8.59688 11.2917C8.96353 11.0158 9.46534 11.0275 9.81726 11.3058L9.90931 11.3883L12.2939 13.805L17.5206 9H16.9985C16.4859 9 16.0633 8.61396 16.0056 8.11662L15.9988 8C15.9988 7.48716 16.3848 7.06449 16.882 7.00673L16.9985 7H19.9977C20.5104 7 20.9329 7.38604 20.9907 7.88338L20.9974 8V11C20.9974 11.5523 20.5498 12 19.9977 12C19.485 12 19.0625 11.614 19.0047 11.1166L18.998 11Z"
      fill="#636363"
    />
  </svg>
</template>
